module.exports = __webpack_public_path__ + "static/media/Kadra.24744169.jpg";